const CART_DOMAIN = 'cart'
const CART_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const CART_ENDPOINT = {
  ADD_PRODUCT: '/cart/addProduct'
}

export {
  CART_DOMAIN,
  CART_ENDPOINT,
  CART_STATE
}
